import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MxTranslateService} from '../../../../../mx-core/src/lib/shared/services/mx-translate.service';
import {PrlLanguageService} from '../../view/prl-language/services/prl-language.service';

@Injectable({
    providedIn: 'root'
})
export class PrlTranslateService implements MxTranslateService {

    constructor(
        protected languageService: PrlLanguageService) {
    }

    get translationsChanged$(): Observable<string> {
        return this.languageService.language;
    }

    getTranslatedLabel(label: string): string {
        return this.languageService.getLabel(label);
    }
}
